import { defineStore } from 'pinia'
import axios from '@/app/plugins/Axios';

export const usePedidosCompraStore = defineStore('pedidoscompra', {

  state: () => ({
    pedidoscompra: [],
  }),

  actions: {

    async listar(filtro) {
      try {
        const response = await axios.get("/pedidoscompra/entrada", { params: filtro }).then(response => response.data);
        this.pedidoscompra = response;
      } catch (error) {
        throw error;
      }
    },

  }

})


